<template>
    <Layout is-crm :content-class="'content--narrow'">
        <div class="container">
            <Spinner v-if="loading" />
            <UsersRepeater
                v-if="!loading && Object.keys(schema).length"
                :schema="schema"
                :languages="languages"
                :loading="loading"
                :error="error"
                trigger-text="crm.employees.repeater.trigger"
                @cancel="cancel"
                @save="save"
            >
                <template #header>
                    <Grid>
                        <Column>
                            <h3 v-text="$t('crm.employees.add.title')"></h3>
                        </Column>
                    </Grid>
                </template>
            </UsersRepeater>
        </div>
    </Layout>
</template>

<script>
import { createEmployees, fetchEmployeesLanguages } from '../../api/employees';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { UsersRepeater } from '../../../users/components';
import { mapActions } from 'vuex';

export default {
    name: 'EmployeesCreatePage',
    components: {
        Grid,
        Column,
        Layout,
        Spinner,
        UsersRepeater,
    },
    data() {
        return {
            loading: false,
            error: undefined,
            languages: undefined,
        };
    },
    computed: {
        schema() {
            const { schema = {} } = this.$store.state.employee;
            return schema.create_users || {};
        },
    },
    async created() {
        this.loading = true;

        try {
            await Promise.all([this.fetchSchema(), this.fetchLanguages()]);
        } catch (e) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions('employee', ['fetchSchema']),

        async fetchLanguages() {
            this.loading = true;

            try {
                this.languages = await fetchEmployeesLanguages();
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        cancel() {
            this.$router.push({ name: 'editors' });
        },
        async save({ users }) {
            this.loading = true;

            try {
                const response = await createEmployees({ users });
                console.log(response);
                this.$router.push({ name: 'editors' });
            } catch (e) {
                this.error = e;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" src="./EmployeesCreatePage.scss"></style>
